import KitAPI from "../KitAPI";
import KitLog from "../KitLog";
import {IapConstants} from "./IapConst";
import {KitIAP} from "./KitIap";
import {RiskBean} from "./RiskBean";
import {JsonData} from "@/Fwk/Kit/JsonData";

export class RiskFactory {
    private static CONDITION_IS = "is";
    private static CONDITION_CO = "co";
    private static CONDITION_BL = "bl";
    private static CONDITION_NBL = "nbl";

    static mrResponse(scene: number, restrict: number, reason: JsonData): RiskBean {
        return new RiskBean(scene, IapConstants.NOT_EARS, "", restrict, reason);
    }


    /// <summary>
    /// 兜底配置
    /// </summary>
    static mrResponseDef(scene: number, defJson: JsonData, reqJson: JsonData): RiskBean {
        return this.GetEars(scene, defJson, reqJson);
    }

    private static GetEars(scene: number, defJson: JsonData, reqJson: JsonData): RiskBean {
        var restrict = KitIAP.NO_RESTRICT;
        var isDef = IapConstants.EARS_NO_RESTRICT;
        var defRule = "";

        try {
            // 兜底策略
            const defualtConfigJson = defJson.OptJsonDataArray(scene.toString());
            const extFilds = new JsonData(reqJson.OptJOb(IapConstants.EXT_FIELDS));
            if (KitLog.IsLog) {
                KitIAP.Log(`scene=${scene}, 用户信息：${extFilds}`);
                KitIAP.LogLongText("兜底配置解析：", defJson.toString());
                if (defualtConfigJson && defualtConfigJson.length > 0) {
                    for (var i = 0; i < defualtConfigJson?.length; i++) {
                        KitIAP.Log(`scene=${scene}, 兜底配置[${i}]：${defualtConfigJson[i].toString()}`);
                    }
                }
            }

            if (defualtConfigJson && defualtConfigJson.length > 0) {
                for (let jObject of defualtConfigJson) {
                    var configJson = new JsonData(jObject);
                    var condition = configJson.OptString("ft_condition");
                    var group = configJson.OptString("ft_group");
                    var field = configJson.OptString("ft_field");
                    var extGroupJson = new JsonData(extFilds.OptJOb(group));

                    if (condition == this.CONDITION_IS) {
                        const earsValue = configJson.OptBoolean("ft_val");
                        const curValue = extGroupJson.OptBoolean(field);
                        if (earsValue == curValue) {
                            if (KitLog.IsLog)
                                KitIAP.Log(`scene=${scene}, 命中限制条件=${field},匹配规则=${condition},curValue=${curValue} == earsValue=${earsValue}`);
                            restrict = KitIAP.RESTRICT;
                            isDef = IapConstants.EARS_RESTRICT;
                            // defRule = configJson.ToString();
                            defRule = group + "-" + field + "-" + earsValue + "=" + curValue;
                            break;
                        }
                    } else if (condition == this.CONDITION_CO) {
                        const earsValue = configJson.OptString("ft_val");
                        const curValue = extGroupJson.OptString(field);
                        if (curValue.concat(earsValue)) {
                            if (KitLog.IsLog) KitIAP.Log(`scene=${scene}, 命中限制条件=${field},匹配规则=${condition} ,curValue=${curValue} contains earsValue=${earsValue}`);
                            restrict = KitIAP.RESTRICT;
                            isDef = IapConstants.EARS_RESTRICT;

                            defRule = group + "-" + field + "-" + earsValue + "=" + curValue;
                            break;
                        }
                    } else if (condition == this.CONDITION_BL) {
                        const earsValue = configJson.OptString("ft_val");
                        const splits = earsValue.split(',');
                        const curValue = extGroupJson.OptString(field);
                        if (splits.concat(curValue)) {
                            if (KitLog.IsLog) KitIAP.Log(`scene=${scene}, 命中限制条件=${field},匹配规则=${condition},curValue=${curValue} belong earsValue=${earsValue}`);
                            restrict = KitIAP.RESTRICT;
                            isDef = IapConstants.EARS_RESTRICT;
                            // defRule = configJson.ToString();
                            defRule = group + "-" + field + "-" + earsValue + "=" + curValue;
                            break;
                        }
                    } else if (condition == this.CONDITION_NBL) {
                        var earsValue = configJson.OptString("ft_val");
                        var splits = earsValue.split(',');
                        var curValue = extGroupJson.OptString(field);
                        if (!splits.concat(curValue)) {
                            if (KitLog.IsLog) KitIAP.Log(`scene=${scene}, 命中限制条件=${field},匹配规则=${condition},curValue=${curValue} no belong earsValue=${earsValue}`)
                            ;
                            restrict = KitIAP.RESTRICT;
                            isDef = IapConstants.EARS_RESTRICT;
                            // defRule = configJson.ToString();
                            defRule = group + "-" + field + "-" + earsValue + "=" + curValue;
                            break;
                        }
                    }
                }
            }
        } catch (e) {
            if (KitLog.IsLog) KitIAP.LogWarning(`兜底配置解析失败：${e}`);
        }

        var result = new JsonData();
        result.put("code", -1);
        var data = new JsonData();
        data.put(IapConstants.RESTRICT, restrict);
        result.put(IapConstants.DATA, data);
        result.put("message", "timeout return");
        result.put("timestamp", KitAPI.GetNowMills());
        if (KitLog.IsLog) KitIAP.Log(`scene=${scene}, 兜底策略返回结果:${result}`);
        return new RiskBean(scene, isDef, defRule, restrict, result);
    }
}
